import packageKey from './packageKey';

export default (day, pkg) => `${packageKey(day)}-${pkg.item_id}`;
